import type { Theme } from '@mui/material/styles';

/**
 * Remove "px" from the return value of theme.spacing()
 */
export function getSpacing(theme: Theme, value: number) {
    return Number(theme.spacing(value).slice(0, -2));
}
